export const PLANS = {
    NOPLAN: 'NOPLAN',
    FREE: 'FREE',
    BASIC: 'BASIC',
    TEAM: 'team-plan',
    BUSINESS: 'BUSINESS',
    ENTERPRISE: 'ENTERPRISE',
    UNLIMITED: 'UNLIMITED'
  } as const;

  export const PURCHASE_CHANNEL = {
    WEB: 0,
    ANDROID: 1,
    IOS: 2
  } as const;

  export type PurchaseChannel = typeof PURCHASE_CHANNEL[keyof typeof PURCHASE_CHANNEL];
